<template>
  <v-container class="my-8">
    <v-row class="w--100">
      <v-col cols="12" md="8">
        <h4 class="mb-2 fieldset-title">انتخاب حوزه‌های فعالیت کسب و کار شما</h4>
      </v-col>
      <v-col cols="12" md="5">
        <v-select
          open-on-click
          label="نوع فعالیت"
          outlined
          persistent-hint
          item-text="displayName"
          item-value="title"
          dense
          required
          return-object
          :menu-props="{
            closeOnClick: true,
            closeOnContentClick: true,
          }"
          v-model="merchantCategoryTypes"
          :items="filteredMerchantCategoryTypeItems"
          @change="getCategoriesTreeList"
          hide-details
        />
      </v-col>
      <v-col
        cols="12"
        md="5"
        v-if="activeSelectedItem && activeSelectedItem.activeTreeItem"
      >
        <v-text-field
          label="جستجو"
          outlined
          dense
          type="text"
          required
          v-model="searchTreeList"
          append-icon="mdi-magnify"
          hide-details
        />
      </v-col>
      <v-col
        cols="3"
        md="2"
        v-if="activeSelectedItem && activeSelectedItem.activeTreeItem"
      >
        <v-btn color="error" @click="closeTree ">بستن</v-btn>
      </v-col>
    </v-row>
    <template v-if="activeSelectedItem && activeSelectedItem.activeTreeItem">
      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-card-title>
              <span class="blue--text text--darken-5">{{
                activeSelectedItem.item.displayName
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-treeview
                :ref="`treeView${activeSelectedItem.item.title}`"
                item-text="name"
                item-key="id"
                item-children="subcategories"
                :items="activeSelectedItem.treeList"
                :search="searchTreeList"
                color="primary"
                transition
                :open.sync="activeSelectedItem.openTreeItem"
                return-object
              >
                <template v-slot:label="props">
                  <div class="treeCheckBox">
                    <v-checkbox
                      v-if="props.item.isLeaf"
                      v-model="activeSelectedItem.activeTreeItem"
                      class="mt-0"
                      hide-details
                      :value="props.item"
                      :label="props.item.name"
                      small
                      dense
                      :ripple="false"
                      @change="selectTree"
                    >
                    </v-checkbox>
                    <span v-else class="f-s-13 text-right">{{
                      props.item.name
                    }}</span>
                  </div>
                </template>
              </v-treeview>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const categoryRepository = () => RepoFactory.get('category');
const supplierProductRepository = () => RepoFactory.get('supplierProduct');

import MerchantCategoryComponentVue from './MerchantCategoryComponent.vue';

export default {
  components: {
    MerchantCategoryComponentVue,
  },
  props:{
    listItems :{
      type:Array,
      default:[]
    }
  },
  data() {
    return {
      supplierProductCategoryTypes: [],
      CategoryTypeItems: [],
      merchantCategoryTypes: [],
      merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'categoryName',
          text: 'دسته فرایند',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },

        {
          value: 'actions',
          text: 'عملیات',
          sortable: false,
        },
      ],
      actvieList: [],
      leafs :[],
      activeSelectedItem: null,
      searchTreeList: null,
      selectionItems: [],
      activeTreeItem: [],
      form: {
        categoryIds: [],
        categoryTypes: [],
      },
      merchantCategoriesList: [],
    };
  },
  watch: {
   'activeSelectedItem.openTreeItem':function (after, before) {
    if(after && after.length  ){
      let flag = true
      after.forEach((x,i)=>{
        if(x.id == this.activeSelectedItem.treeList[0].id){
          flag = false
        }
        
      })
      if(flag){
        
        this.activeSelectedItem.openTreeItem = []
      }
    }
   },
    'activeSelectedItem.activeTreeItem': function (after, before) {
      if (
        this.activeSelectedItem &&
        (this.activeSelectedItem.item == null ||
          this.activeSelectedItem.item.length == 0)
      ) {
        this.activeSelectedItem.treeList = [];
      }
      if (after && before && after.length > before.length) {
        this.addCategory(after[after.length - 1].id);
      } else if (after && before && after.length < before.length) {
        before.forEach((x) => {
          let flag = false;
          after.forEach((y) => {
            if (JSON.stringify(x) == JSON.stringify(y)) {
              flag = true;
            }
          });
          if (!flag) {
            this.$emit('deleteFromTree', x);
          }
        });
      }
    },
    'form.categoryIds': function () {
      this.$emit('tableInfo', this.form.categoryIds);
    },

    '$store.getters.currentMerchantObject': function () {
      this.getSupplierProductCategoryTypes();
    },
  },
  computed: {
    checkIfSelectedTreeNode() {
      return (
        this.selectionItems.length &&
        this.selectionItems.find((el) => el.activeTreeItem.length)
      );
    },
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    filteredMerchantCategoryTypeItems() {
      return this.CategoryTypeItems.filter((el) =>
        this.supplierProductCategoryTypes.includes(el.title)
      );
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },

  methods: {
    selectedActivitiesTypes() {
      if (this.form.categoryTypes.length) {
        return this.actvieList.filter((el) =>
          this.form.categoryTypes.includes(el.title)
        );
      } else {
        return [];
      }
    },
    getSupplierProductCategoryTypes() {
      let obj = this.$store.getters.currentMerchantObject;
      return new Promise((resolve, reject) => {
        const params = {
          supplierIsManufacturer: obj.isManufacturer,
        };
        supplierProductRepository()
          .getSupplierProductCategoryTypes(
            this.$store.getters.productBaseUrl,
            params
          )
          .then(({ data }) => {
            this.supplierProductCategoryTypes = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
            this.CategoryTypeItems = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCategoriesTreeList(val) {
      const loader = this.$loading.show();
      const param = {};
      param.categoryTypes = val.title;
      categoryRepository()
        .getCategoriesTreeListMoreData(
          this.$store.getters.productBaseUrl,
          { merchantId: this.merchantId },
          param
        )
        .then((res) => {
          const data = {
            item: val,
            treeList: res.data,
            activeTreeItem: [],
            openTreeItem: res.data,
          };
          this.$set(this.selectionItems, this.selectionItems.length, data);
          this.activeSelectedItem = data;
          this.traverseTree()
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getMerchantCategoriesByIds() {
      const ids = this.activeSelectedItem.activeTreeItem.map((el) => {
        return el.id;
      });
      if (this.form.categoryIds == undefined || this.form.categoryIds == null) {
        this.form.categoryIds = [];
      }

      this.form.categoryIds = ids;

      this.activeSelectedItem.activeTreeItem.forEach((el) => {
        if (!this.form.categoryTypes.includes(el.categoryType)) {
          this.form.categoryTypes.push(el.categoryType);
        }
      });
      // });
    },
    selectTree(val) {
      if (val && val.length) {
        this.getMerchantCategoriesByIds();
      } else {
        this.merchantCategoriesList = [];
        this.form.categoryIds = null;
      }
    },
    deSelectTree() {
      this.selectionItems.forEach((element) => {
        element.activeTreeItem = [];
      });
    },
    removeMerchantCategoriesList(item) {
      // step:1 remove from merchant categories list
      this.merchantCategoriesList = this.merchantCategoriesList.filter(
        (el) => el.categoryId !== item.categoryId
      );
      this.form.categoryIds = this.form.categoryIds.filter(
        (el) => el !== item.categoryId
      );
      // step:2 remove from selected tree items
      this.activeSelectedItem.activeTreeItem =
        this.activeSelectedItem.activeTreeItem.filter(
          (el) => el.id != item.categoryId
        );
      // step:3 remove from categoryTypes if removed merchant
      // category is not exist in categoryTypes
      const categoryTypeTitle = item.categoryTypeTitle;
      if (
        !this.merchantCategoriesList.find(
          (el) => el.categoryTypeTitle == categoryTypeTitle
        )
      ) {
        this.form.categoryTypes.splice(
          this.form.categoryTypes.indexOf(categoryTypeTitle),
          1
        );
        this.merchantCategoryTypes.splice(
          this.form.categoryTypes.indexOf(
            (el) => el.title == categoryTypeTitle
          ),
          1
        );
      }
    },
    closeTree() {
      this.activeSelectedItem = null;
      (this.activeTreeItem = []), (this.merchantCategoriesList = []);
      this.merchantCategoryTypes = null;
      this.$emit('addBtn')
    },
    addCategory(id) {
      let app = this
      let ids = [];
      const loader = this.$loading.show();
      this.merchantCategoriesList.forEach((x) => {
        ids.push(x.categoryId);
      });
      categoryRepository()
        .addCategoryBySupplier({ categoryId: id }, this.productBaseUrl, {
          merchantId: this.$store.getters.currentMerchant,
        })
        .then(() => {
          this.$dialog.message.success('حوزه فعالیت انتخاب شده با موفقیت ثبت و به ادمین ارسال شد، منتظر بررسی ادمین باشید.', {
            position: 'top-left',
          });
          categoryRepository()
            .getMerchantCategoryByCategoryId(
              this.productBaseUrl,
              { merchantId: this.$store.getters.currentMerchant },
              { categoryId: id }
            )
            .then((res) => {
              app.activeSelectedItem.activeTreeItem.forEach((x, i) => {
                
                if (x.id == id) {
                  x.merchantCategoryId = res.data.id;
                }
              });
            })
            .catch((err) => {
              Helper.handleErrors(err, this);
            });

          this.merchantCategoriesList = [];
          this.$emit('getData');
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    traverseTree() {
     this.activeSelectedItem
     let leafs =[]
     leafs = this.findLeafs(this.activeSelectedItem.treeList)
     
     let list
     list = this.listItems.filter(item=> item.categoryTypeItem == this.merchantCategoryTypes.title)
      
      list.forEach(item=>{
        leafs.forEach(leaf =>{
          if(item.categoryId == leaf.id){
            
            this.activeSelectedItem.activeTreeItem.push(leaf)
          }
        })
      })
    },
    findLeafs(root){
      for (let i = 0; i < root.length; i++) {
        const element = root[i];
        if (element.isLeaf)  {
          
          this.leafs.push(element);
          }
        else if(!element.isLeaf && element.subcategories.length){
          this.findLeafs(element.subcategories);
        }
      }
    
      return this.leafs;
    },
  },

  created() {
    this.getCategoryTypeItems();
    if (this.$store.getters.currentMerchantObject) {
      this.getSupplierProductCategoryTypes();
    }
  },
};
</script>

<style></style>
